<template>
  <proa-card :class="['h-100 d-flex flex-column', { 'disabled': requesting }]" no-padding>
    <template v-slot:header>
      <div class="d-flex justify-content-between align-items-center">
        <proa-back-button
          @onClick="$emit('onClickBackButton')"
        />
        <proa-heading detail>{{ $t('pages.management.basicInformation.changeLicensePlan') }}</proa-heading>
        <div/>
      </div>
    </template>
    <div class="edit-card-body">
      <div class="table-outer-wrapper">
          <div class="table-inner-scroll-wrapper">
            <table class="table-edit-license-plan">
              <thead>
                <tr>
                  <th>
                  </th>
                  <th class="license-plan-in-use">
                    <div>{{ $t('pages.editManagementLicensePlan.planInUse') }}</div>
                  </th>
                  <th class="license-plan-after-change">
                    <div>{{ $t('pages.editManagementLicensePlan.planAfterChange') }}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="white-row">
                  <th class="font-weight-w7">{{ $t('common.plan') }}</th>
                  <td :class="{ 'double-row small-row d-table-cell': alreadyAppliedCoupon && applyDiscountRate }">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>{{ currentLicensedPlan.planName }}</div>
                      <div>{{ currentLicensedPlan.price | currencyJPY }} / {{ $t('common.month') }}</div>
                    </div>
                    <div v-if="alreadyAppliedCoupon && applyDiscountRate" class="discount font-weight-w6">
                      <span class="mr-3">クーポン割引</span>
                      <span>-{{ (currentLicensedPlan.price * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}</span>
                    </div>
                  </td>
                  <td :class="{ 'double-row small-row d-table-cell': (editedLicensePlan || alreadyAppliedCoupon) && applyDiscountRate }">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <proa-select
                          v-model="innerLicensePlan.licensePlanMasterId"
                          :options="licensePlanMasterOptions"
                          class="license-plan-select"
                          @input="onInputLicensePlanMasterId"
                        />
                      </div>
                      <div class="font-weight-w6">{{ afterLicensePlan.price | currencyJPY }} / {{ $t('common.month') }}</div>
                    </div>
                    <div v-if="(editedLicensePlan || alreadyAppliedCoupon) && applyDiscountRate" class="discount font-weight-w6">
                      <span class="mr-3">クーポン割引</span>
                      <span>-{{ (afterLicensePlan.price * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}</span>
                    </div>
                  </td>
                </tr>
                <tr class="gray-row slim">
                  <th>{{ $t('models.licensedPlan.attributes.maxUsers') }}</th>
                  <td>
                    <span>{{ currentLicensedPlan.maxUsers + $t('common.person') }}</span>
                    <span v-if="beforeSeatTotalUsersCount"> ＋ {{ beforeSeatTotalUsersCount + $t('common.person') }}</span>
                  </td>
                  <td class="font-weight-w6">
                    <span>{{ afterLicensePlan.maxUsers + $t('common.person') }}</span>
                    <span v-if="afterSeatTotalUsersCount"> ＋ {{ afterSeatTotalUsersCount + $t('common.person') }}</span>
                  </td>
                </tr>
                <tr class="white-row slim">
                  <th>{{ $t('models.licensedPlan.attributes.maxGroups') }}</th>
                  <td>{{ currentLicensedPlan.maxGroups || $t('common.unlimited') }}</td>
                  <td class="font-weight-w6">{{ afterLicensePlan.maxGroups || $t('common.unlimited') }}</td>
                </tr>
                <tr class="gray-row slim">
                  <th>{{ $t('models.licensedPlan.attributes.maxFileSize') }}</th>
                  <td>{{ currentLicensedPlan.maxFileSize + $t('common.mb') }}</td>
                  <td class="font-weight-w6">{{ afterLicensePlan.maxFileSize + $t('common.mb') }}</td>
                </tr>
                <tr class="white-row slim separate-bottom">
                  <th>{{ $t('models.licensedPlan.attributes.maxStoreDuration') }}</th>
                  <td>{{ currentLicensedPlan.maxStoreDuration + $t('common.months') }}</td>
                  <td class="font-weight-w6">{{ afterLicensePlan.maxStoreDuration + $t('common.months') }}</td>
                </tr>
                <tr class="white-row">
                  <th class="font-weight-w7">追加オプション</th>
                  <td></td>
                  <td></td>
                </tr>
                <tr
                  v-for="(planMaster, index) of seatPlanMasters.concat(roomPlanMasters)"
                  :key="index"
                  :class="index % 2 == 0 ? 'gray-row' : 'white-row'"
                >
                  <!-- NOTE: seatTypeでオプションの種別を判定 -->
                  <template v-if="planMaster.seatType">
                    <th>
                      <div>{{ planMaster.seatPlanName }}（{{ planMaster.maxSeats + $t('common.person') }}）</div>
                      <div>{{ planMaster.price | currencyJPY }} / {{ $t('common.month') }}</div>
                    </th>
                    <td :class="{ 'double-row small-row d-table-cell': alreadyAppliedCoupon && applyDiscountRate && beforeSeatPlanMastersCountById(planMaster.id) != 0 }">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>{{ beforeSeatPlanMastersCountById(planMaster.id) }}</div>
                        <div>{{ planMaster.price * beforeSeatPlanMastersCountById(planMaster.id) | currencyJPY }} / {{ $t('common.month') }}</div>
                      </div>
                      <div v-if="alreadyAppliedCoupon && applyDiscountRate && beforeSeatPlanMastersCountById(planMaster.id) != 0" class="discount font-weight-w6">
                        <span class="mr-3">クーポン割引</span>
                        <span>-{{ ((planMaster.price * beforeSeatPlanMastersCountById(planMaster.id)) * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}</span>
                      </div>
                    </td>
                    <td :class="{ 'disabled': afterLicensePlan.contractType === 'free', 'double-row small-row': (editedLicensePlan || alreadyAppliedCoupon) && applyDiscountRate && afterSeatPlanMastersCountById(planMaster.id) != 0 }">
                      <div class="d-flex justify-content-between align-items-center font-weight-w6">
                        <div>
                          <proa-select
                            :value="afterSeatPlanMastersCountById(planMaster.id)"
                            :options="seatPlanMastersCountOptionsById(planMaster.id)"
                            :selected="afterSeatPlanMastersCountById(planMaster.id)"
                            :disabled="afterLicensePlan.contractType === 'free'"
                            class="option-count-select"
                            @input="(value) => onInputSeatPlanMastersCountSelect(planMaster.id, value)"
                          />
                        </div>
                        <div>{{ planMaster.price * afterSeatPlanMastersCountById(planMaster.id) | currencyJPY }} / {{ $t('common.month') }}</div>
                      </div>
                      <div v-if="(editedLicensePlan || alreadyAppliedCoupon) && applyDiscountRate && afterSeatPlanMastersCountById(planMaster.id) != 0" class="discount font-weight-w6">
                        <span class="mr-3">クーポン割引</span>
                        <span>-{{ ((planMaster.price * afterSeatPlanMastersCountById(planMaster.id)) * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}</span>
                      </div>
                    </td>
                  </template>
                  <template v-else>
                    <th>
                      <div>{{ planMaster.roomPlanName }}（{{ $t('common.max') + planMaster.roomCapacity + $t('common.person') }}）</div>
                      <div>{{ planMaster.price | currencyJPY }} / {{ $t('common.month') }}</div>
                    </th>
                    <td :class="{ 'double-row small-row d-table-cell': alreadyAppliedCoupon && applyDiscountRate && beforeRoomPlanMastersCountById(planMaster.id) != 0 }">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>{{ beforeRoomPlanMastersCountById(planMaster.id) }}</div>
                        <div>{{ planMaster.price * beforeRoomPlanMastersCountById(planMaster.id) | currencyJPY }} / {{ $t('common.month') }}</div>
                      </div>
                      <div v-if="alreadyAppliedCoupon && applyDiscountRate && beforeRoomPlanMastersCountById(planMaster.id) != 0" class="discount font-weight-w6">
                        <span class="mr-3">クーポン割引</span>
                        <span>-{{ ((planMaster.price * beforeRoomPlanMastersCountById(planMaster.id)) * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}</span>
                      </div>
                    </td>
                    <td :class="{ 'disabled': afterLicensePlan.contractType === 'free', 'double-row small-row d-table-cell': (editedLicensePlan || alreadyAppliedCoupon) && applyDiscountRate && afterRoomPlanMastersCountById(planMaster.id) != 0 }">
                      <div class="d-flex justify-content-between align-items-center font-weight-w6">
                        <div>
                          <proa-select
                            :value="afterRoomPlanMastersCountById(planMaster.id)"
                            :options="roomPlanMastersCountOptionsById(planMaster.id)"
                            :disabled="afterLicensePlan.contractType === 'free'"
                            class="option-count-select"
                            @input="(value) => onInputRoomPlanMastersCountSelect(planMaster.id, value)"
                          />
                        </div>
                        <div>{{ planMaster.price * afterRoomPlanMastersCountById(planMaster.id) | currencyJPY }} / {{ $t('common.month') }}</div>
                      </div>
                      <div v-if="(editedLicensePlan || alreadyAppliedCoupon) && applyDiscountRate && afterRoomPlanMastersCountById(planMaster.id) != 0" class="discount font-weight-w6">
                        <span class="mr-3">クーポン割引</span>
                        <span>-{{ ((planMaster.price * afterRoomPlanMastersCountById(planMaster.id)) * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}</span>
                      </div>
                    </td>
                  </template>
                </tr>
                <tr :class="['white-row separate', { 'edited': (editedLicensePlan || alreadyAppliedCoupon) }]">
                  <th class="font-weight-w7">{{ $t('common.totalPrice') }}</th>
                  <td>
                    <div class="d-flex justify-content-between align-items-center">
                      <div>{{ $t('pages.editManagementLicensePlan.beforeTotalPrice') }}</div>
                      <div v-if="alreadyAppliedCoupon && applyDiscountRate">
                        {{ beforeMonthlyPrice - (beforeMonthlyPrice * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}
                      </div>
                      <div v-else>
                        {{ beforeMonthlyPrice | currencyJPY }} / {{ $t('common.month') }}
                      </div>
                    </div>
                  </td>
                  <td :class="{ 'double-row d-table-cell': (editedLicensePlan || alreadyAppliedCoupon) && appliedCoupon }">
                    <div :class="['after-monthly-price d-flex justify-content-between align-items-center font-weight-w6', { 'applied-coupon': (editedLicensePlan || alreadyAppliedCoupon) && appliedCoupon }]">
                      <div class="after-total-price-title">
                        {{ $t('pages.editManagementLicensePlan.afterTotalPrice') }}
                        <div v-if="(editedLicensePlan || alreadyAppliedCoupon) && appliedCoupon" class="applied-coupon-label">
                          <span class="check-mark"></span>
                          <span class="ml-2">クーポン適用</span>
                        </div>
                      </div>
                      <div v-if="(editedLicensePlan || alreadyAppliedCoupon) && applyDiscountRate">
                        {{ afterMonthlyPrice - (afterMonthlyPrice * (applyDiscountRate / 100)) | currencyJPY }} / {{ $t('common.month') }}
                      </div>
                      <div v-else>
                        {{ afterMonthlyPrice | currencyJPY }} / {{ $t('common.month') }}
                      </div>
                    </div>
                    <div v-if="applyTrialEndAt" class="apply-trial-end-at font-weight-w6">
                      <span class="mr-3">無料トライアル期間</span>
                      <span>{{ applyTrialEndAt }}</span>
                    </div>
                  </td>
                </tr>
                <tr class="white-row">
                  <td colspan="3" class="text-secondary text-center py-4">
                    <div>
                      <span>{{ $t('pages.editManagementLicensePlan.toServicePlanInformation') }}</span>
                      <router-link :to="{ name: 'servicePlans' }" class="text-link" target="_blank">{{ $t('common.here') }}</router-link>
                    </div>
                    <div>{{ $t('pages.editManagementLicensePlan.precautionaryStatement') }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
    <div class="edit-card-footer">
      <proa-button
        v-if="editedLicensePlan && !account.trialEndAt && !appliedCoupon"
        :loading="requesting"
        @click.native="$emit('onClickInputCouponCode')"
      >
        クーポンコードの入力
      </proa-button>
      <proa-button
        v-else-if="!alreadyAppliedCoupon && editedLicensePlan && appliedCoupon"
        :loading="requesting"
        @click.native="$emit('onClickDeleteCouponCode')"
      >
        クーポンコードを削除
      </proa-button>
      <proa-button
        class="default-button-width ml-4"
        variant="primary"
        :disabled="!editedLicensePlan"
        :loading="requesting"
        @click.native="$emit('onClickChangeLicensePlan', innerLicensePlan)"
      >
        {{ $t('common.change') }}
      </proa-button>
    </div>
  </proa-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'LicensePlanEditFormCard',
  props: {
    account: Object,
    alreadyAppliedCoupon: Boolean,
    appliedCoupon: Object,
    currentLicensedPlan: Object,
    licensePlanMasters: Array,
    requesting: Boolean,
    roomPlanMasters: Array,
    seatPlanMasters: Array
  },
  computed: {
    applyTrialEndAt: function() {
      if (this.account.trialEndAt || !this.editedLicensePlan) {
        return null
      } else if (this.appliedCoupon?.trialDuration) {
        return moment().add(this.appliedCoupon?.trialDuration - 1, 'months').endOf('month').format("YYYY年MM月DD日")
      } else {
        return moment().endOf('month').format("YYYY年MM月DD日")
      }
    },
    applyDiscountRate: function() {
      return this.appliedCoupon?.discountRate
    },
    afterLicensePlan: function() {
      return this.licensePlanMasters.filter((licensePlanMaster) => licensePlanMaster.id == this.innerLicensePlan.licensePlanMasterId)[0]
    },
    afterMonthlyPrice: function() {
      const afterLicensePlanMasterPrice = this.afterLicensePlan.price
      const afterRoomPlanMastersPrice = this.innerLicensePlan.roomPlanMasterIds.map(roomPlanMasterId => {
        return this.roomPlanMasters.filter((roomPlanMaster) => roomPlanMasterId == roomPlanMaster.id)[0]?.price
      }).filter((v) => v).reduce((a, b) => a + b, 0)
      const afterSeatPlanMastersPrice = this.innerLicensePlan.seatPlanMasterIds.map(seatPlanMasterId => {
        return this.seatPlanMasters.filter((seatPlanMaster) => seatPlanMasterId == seatPlanMaster.id)[0]?.price
      }).filter((v) => v).reduce((a, b) => a + b, 0)
      return afterLicensePlanMasterPrice + afterRoomPlanMastersPrice + afterSeatPlanMastersPrice
    },
    afterRoomPlanMastersCountById: function() {
      return function(id) {
        return this.innerLicensePlan.roomPlanMasterIds.filter(roomPlanMasterId => roomPlanMasterId == id).length
      }
    },
    afterSeatTotalUsersCount: function() {
      return this.innerLicensePlan.seatPlanMasterIds.map(seatPlanMasterId => {
        return this.seatPlanMasters.filter((seatPlanMaster) => seatPlanMasterId == seatPlanMaster.id)[0]?.maxSeats
      }).filter((v) => v).reduce((a, b) => a + b, 0)
    },
    afterSeatPlanMastersCountById: function() {
      return function(id) {
        return this.innerLicensePlan.seatPlanMasterIds.filter(seatPlanMasterId => seatPlanMasterId == id).length
      }
    },
    beforeMonthlyPrice: function() {
      const beforeLicensePlanMasterPrice = this.licensePlanMasters.filter((licensePlanMaster) => licensePlanMaster.id == this.currentLicensedPlan.licensePlanMasterId)[0].price
      const beforeRoomPlanMastersPrice = this.currentLicensedPlan.roomPlanMasterIds.map(roomPlanMasterId => {
        return this.roomPlanMasters.filter((roomPlanMaster) => roomPlanMasterId == roomPlanMaster.id)[0]?.price
      }).filter((v) => v).reduce((a, b) => a + b, 0)
      const beforeSeatPlanMastersPrice = this.currentLicensedPlan.seatPlanMasterIds.map(seatPlanMasterId => {
        return this.seatPlanMasters.filter((seatPlanMaster) => seatPlanMasterId == seatPlanMaster.id)[0]?.price
      }).filter((v) => v).reduce((a, b) => a + b, 0)
      return beforeLicensePlanMasterPrice + beforeRoomPlanMastersPrice + beforeSeatPlanMastersPrice
    },
    beforeRoomPlanMastersCountById: function() {
      return function(id) {
        return this.currentLicensedPlan.roomPlanMasterIds.filter(roomPlanMasterId => roomPlanMasterId == id).length
      }
    },
    beforeSeatTotalUsersCount: function() {
      return this.currentLicensedPlan.seatPlanMasterIds.map(seatPlanMasterId => {
        return this.seatPlanMasters.filter((seatPlanMaster) => seatPlanMasterId == seatPlanMaster.id)[0]?.maxSeats
      }).filter((v) => v).reduce((a, b) => a + b, 0)
    },
    beforeSeatPlanMastersCountById: function() {
      return function(id) {
        return this.currentLicensedPlan.seatPlanMasterIds.filter(seatPlanMasterId => seatPlanMasterId == id).length
      }
    },
    editedLicensePlan: function() {
      return this.currentLicensedPlan.licensePlanMasterId != this.innerLicensePlan.licensePlanMasterId ||
             this.roomPlanMasters.filter((roomPlanMaster) => {
               return this.currentLicensedPlan.roomPlanMasterIds.filter(i => i == roomPlanMaster.id).length
                      != this.innerLicensePlan.roomPlanMasterIds.filter(i => i == roomPlanMaster.id).length
             }).length != 0 ||
             this.seatPlanMasters.filter((seatPlanMaster) => {
               return this.currentLicensedPlan.seatPlanMasterIds.filter(i => i == seatPlanMaster.id).length
                      != this.innerLicensePlan.seatPlanMasterIds.filter(i => i == seatPlanMaster.id).length
             }).length != 0
    },
    licensePlanMasterOptions: function() {
      return this.licensePlanMasters.map((licensePlanMaster) => {
        return {
          label: licensePlanMaster.planName,
          value: licensePlanMaster.id,
          selected: licensePlanMaster.id == this.currentLicensedPlan.licensePlanMasterId
        }
      })
    },
    roomPlanMastersCountOptionsById: function() {
      return function(id) {
        return [...Array(101)].map((_, i) => {
          return {
            label: i,
            value: i,
            selected: this.afterRoomPlanMastersCountById(id) == i
          }
        })
      }
    },
    seatPlanMastersCountOptionsById: function() {
      return function(id) {
        return [...Array(101)].map((_, i) => {
          return {
            label: i,
            value: i,
            selected: this.afterSeatPlanMastersCountById(id) == i
          }
        })
      }
    }
  },
  data() {
    return {
      innerLicensePlan: null
    }
  },
  methods: {
    onInputLicensePlanMasterId: function() {
      if (this.afterLicensePlan.contractType === 'free') {
        this.innerLicensePlan.roomPlanMasterIds = []
        this.innerLicensePlan.seatPlanMasterIds = []
      }
    },
    onInputRoomPlanMastersCountSelect: function(id, value) {
      this.innerLicensePlan.roomPlanMasterIds = this.innerLicensePlan.roomPlanMasterIds.filter(roomPlanMasterId => roomPlanMasterId != id)
                                                                                       .concat([...Array(Number(value))].map(() => id))
    },
    onInputSeatPlanMastersCountSelect: function(id, value) {
      this.innerLicensePlan.seatPlanMasterIds = this.innerLicensePlan.seatPlanMasterIds.filter(seatPlanMasterId => seatPlanMasterId != id)
                                                                                       .concat([...Array(Number(value))].map(() => id))
    },
    removeSelectedRoomPlanMaster: function(index) {
      this.innerLicensePlan.roomPlanMasterIds.splice(index, 1)
    },
    removeSelectedSeatPlanMaster: function(index) {
      this.innerLicensePlan.seatPlanMasterIds.splice(index, 1)
    }
  },
  created() {
    this.innerLicensePlan = {
      licensePlanMasterId: this.currentLicensedPlan.licensePlanMasterId,
      roomPlanMasterIds: this.currentLicensedPlan.roomPlanMasterIds.slice(),
      seatPlanMasterIds: this.currentLicensedPlan.seatPlanMasterIds.slice()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.edit-card-body {
  flex-grow: 1;

  .table-outer-wrapper {
    position: relative;
    height: 100%;
  }

  .table-inner-scroll-wrapper {
    position: absolute;
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
  }

  .table-edit-license-plan {
    overflow-y: auto;
    height: 100%;
    min-width: 100%;
    white-space: nowrap;
    font-size: 14px;
    table-layout: fixed;

    thead {
      th {
        width: 447px;
        height: 44px;
        position: sticky;
        top: 0;
        font-weight: 600;
        background-color: white;
        z-index: 1;

        &:first-child {
          width: 192px;
        }

        &:first-child:before {
          content: "";
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border-bottom: 1px solid $light-border-color;
        }

        &:first-child {
          width: 192px;
        }

        &.license-plan-in-use {
          background-color: $light-border-color;
          color: $secondary-color;
        }

        &.license-plan-after-change {
          background-color: $secondary-color;
          color: white;
        }

        div {
          text-align: center;
        }
      }
    }

    tbody {
      tr {
        &.gray-row {
          background-color: $light-gray-color;
        }

        &.white-row {
          background-color: white;
        }

        &.slim {
          th, td {
            height: 36px;
          }
        }

        &.separate {
          border-top: 1px solid $light-border-color;
          border-bottom: 1px solid $light-border-color;
        }

        &.separate-bottom {
          border-bottom: 1px solid $light-border-color;
        }

        th, td {
          height: 64px;
          border-right: 1px solid $light-border-color;

          &.double-row {
            height: 128px;
            padding: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            &.small-row {
              height: 96px;
              justify-content: center;
            }

            > div {
              display: flex;
              align-items: center;
              padding: 0 30px;
            }

            .after-monthly-price, .apply-trial-end-at {
              height: 64px;

              &.applied-coupon {
                height: 128px;
              }
            }

            .discount {
              height: 32px;
              color: $secondary-color;
              justify-content: flex-end;
            }

            .apply-trial-end-at {
              background-color: #FDF6E9;
              justify-content: center;
            }
          }
        }

        th {
          color: $secondary-color;
          font-weight: 300;
          padding: 0 20px;
        }

        td {
          padding: 0 30px;

          &:last-child {
            border-right: none;
          }

          .license-plan-select {
            width: 200px;
            height: 34px;
          }

          .option-count-select {
            width: 100px;
            height: 34px;
          }
        }

        &.edited {
          td {
            border-right: none;

            &:last-child {
              outline-offset: -1px;
              outline: 1px solid $primary-color;
            }

            .after-total-price-title {
              color: $primary-color;

              .applied-coupon-label {
                margin-top: 4px;
                padding: 4px;
                width: 100px;
                font-size: 10px;
                border: 1px solid $primary-color;
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;

                .check-mark {
                  position: relative;
                  &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    top: -0.5em;
                    left: -0.6em;
                    width: 10px;
                    height: 6px;
                    border-left: 2px solid $primary-color;
                    border-bottom: 2px solid $primary-color;
                    transform: rotate(-45deg);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.edit-card-footer {
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid $dark-border-color;

  @include mq(md) {
    justify-content: flex-end;
  }
}
</style>
